<template>
  <div class="columns">
    <div class="column">
      <div class="title is-5">{{ $t("final quarters") }}</div>
      <div class="mb-6">
        <div class="mb-3">
          <div
            class="button is-medium match0"
            v-bind:class="{
              'is-info': match_0_winner && match_0_winner == players[0],
            }"
            @click="win(0, players[0], $event)"
          >
            {{ players[0] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match0"
            v-bind:class="{
              'is-info': match_0_winner && match_0_winner == players[1],
            }"
            @click="win(0, players[1], $event)"
          >
            {{ players[1] }}
          </div>
        </div>
      </div>
      <div class="">
        <div class="mb-3">
          <div
            class="button is-medium match2"
            v-bind:class="{
              'is-info': match_2_winner && match_2_winner == players[4],
            }"
            @click="win(2, players[4], $event)"
          >
            {{ players[4] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match2"
            v-bind:class="{
              'is-info': match_2_winner && match_2_winner == players[5],
            }"
            @click="win(2, players[5], $event)"
          >
            {{ players[5] }}
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("semifinal") }}</div>
      <div class="mb-3">
        <div
          class="button is-medium match4"
          v-bind:class="{
            'is-info':
              match_4_winner &&
              match_0_winner &&
              match_4_winner == match_0_winner,
          }"
          @click="win(4, match_0_winner, $event)"
        >
          {{ match_0_winner }}
        </div>
      </div>
      <div>
        <div
          class="button is-medium match4"
          v-bind:class="{
            'is-info':
              match_4_winner &&
              match_2_winner &&
              match_4_winner == match_2_winner,
          }"
          @click="win(4, match_2_winner, $event)"
        >
          {{ match_2_winner }}
        </div>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("final") }}</div>
      <div
        class="button is-medium match6"
        v-bind:class="{
          'is-info':
            match_6_winner &&
            match_4_winner &&
            match_6_winner == match_4_winner,
        }"
        @click="win(6, match_4_winner, $event)"
      >
        {{ match_4_winner }}
      </div>
    </div>
    <div class="column">
      <div class="title is-4 has-text-primary">{{ $t("champion") }}</div>
      <div
        class="button is-medium"
        v-bind:class="{ 'is-warning': match_6_winner }"
      >
        <span class="icon">
          <i class="fa fa-trophy"></i>
        </span>
        <span>{{ match_6_winner }}</span>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("final") }}</div>
      <div
        class="button is-medium match6"
        v-bind:class="{
          'is-info':
            match_6_winner &&
            match_5_winner &&
            match_6_winner == match_5_winner,
        }"
        @click="win(6, match_5_winner, $event)"
      >
        {{ match_5_winner }}
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("semifinal") }}</div>
      <div class="mb-3">
        <div
          class="button is-medium match5"
          v-bind:class="{
            'is-info':
              match_1_winner &&
              match_5_winner &&
              match_5_winner == match_1_winner,
          }"
          @click="win(5, match_1_winner, $event)"
        >
          {{ match_1_winner }}
        </div>
      </div>
      <div>
        <div
          class="button is-medium match5"
          v-bind:class="{
            'is-info':
              match_5_winner &&
              match_3_winner &&
              match_5_winner == match_3_winner,
          }"
          @click="win(5, match_3_winner, $event)"
        >
          {{ match_3_winner }}
        </div>
      </div>
    </div>
    <div class="column">
      <div class="title is-5">{{ $t("final quarters") }}</div>
      <div class="mb-6">
        <div class="mb-3">
          <div
            class="button is-medium match1"
            v-bind:class="{
              'is-info': match_1_winner && match_1_winner == players[2],
            }"
            @click="win(1, players[2], $event)"
          >
            {{ players[2] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match1"
            v-bind:class="{
              'is-info': match_1_winner && match_1_winner == players[3],
            }"
            @click="win(1, players[3], $event)"
          >
            {{ players[3] }}
          </div>
        </div>
      </div>
      <div class="">
        <div class="mb-3">
          <div
            class="button is-medium match3"
            v-bind:class="{
              'is-info': match_3_winner && match_3_winner == players[6],
            }"
            @click="win(3, players[6], $event)"
          >
            {{ players[6] }}
          </div>
        </div>
        <div>
          <div
            class="button is-medium match3"
            v-bind:class="{
              'is-info': match_3_winner && match_3_winner == players[7],
            }"
            @click="win(3, players[7], $event)"
          >
            {{ players[7] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EightPeople",
  props: {
    players: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      match_0_winner: "",
      match_1_winner: "",
      match_2_winner: "",
      match_3_winner: "",
      match_4_winner: "",
      match_5_winner: "",
      match_6_winner: "",
      match_7_winner: "",
    };
  },
  methods: {
    win(round, player, event) {
      if (round === 0) {
        this.match_0_winner = player;
        window.jQuery(".match0").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 1) {
        this.match_1_winner = player;
        window.jQuery(".match1").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 2) {
        this.match_2_winner = player;
        window.jQuery(".match2").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 3) {
        this.match_3_winner = player;
        window.jQuery(".match3").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 4) {
        this.match_4_winner = player;
        window.jQuery(".match4").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 5) {
        this.match_5_winner = player;
        window.jQuery(".match5").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      } else if (round === 6) {
        this.match_6_winner = player;
        window.jQuery(".match6").removeClass("is-info");
        window.jQuery(event.target).addClass("is-info");
      }
    },
    get_results() {
      return {
        matches: {
          0: {
            winner: this.match_0_winner,
            players: [this.players[0], this.players[1]],
          },
          1: {
            winner: this.match_1_winner,
            players: [this.players[2], this.players[3]],
          },
          2: {
            winner: this.match_2_winner,
            players: [this.players[4], this.players[5]],
          },
          3: {
            winner: this.match_3_winner,
            players: [this.players[6], this.players[7]],
          },
          4: {
            winner: this.match_4_winner,
            players: [this.match_0_winner, this.match_2_winner],
          },
          5: {
            winner: this.match_5_winner,
            players: [this.match_1_winner, this.match_3_winner],
          },
          6: {
            winner: this.match_6_winner,
            players: [this.match_4_winner, this.match_5_winner],
          },
        },
      };
    },
    set_results(results) {
      let v = this;
      if (results && results.matches) {
        if (results.matches[0]) {
          v.match_0_winner = results.matches[0].winner;
        }
        if (results.matches[1]) v.match_1_winner = results.matches[1].winner;
        if (results.matches[2]) v.match_2_winner = results.matches[2].winner;
        if (results.matches[3]) v.match_3_winner = results.matches[3].winner;
        if (results.matches[4]) v.match_4_winner = results.matches[4].winner;
        if (results.matches[5]) v.match_5_winner = results.matches[5].winner;
        if (results.matches[6]) v.match_6_winner = results.matches[6].winner;
      }
    },
  },
};
</script>

<style scoped>
/* Your styles here */
</style>
